import React, { useState } from "react";
import {
  HandleOnApproveActionType,
  useCreateBillingAgreement,
  UseCreateBillingAgreementType,
  useHandleOnApproveAction,
  useHandleOnError,
  UseHandleOnErrorType,
} from "./hooks";

type UsePayPalBraintreeButtonsType = {
  isButtonsInitializing: boolean;
  setIsButtonsInitializing: React.Dispatch<React.SetStateAction<boolean>>;
} & UseHandleOnErrorType &
  UseCreateBillingAgreementType &
  HandleOnApproveActionType;

export const usePayPalBraintreeButtons = (): UsePayPalBraintreeButtonsType => {
  const [isButtonsInitializing, setIsButtonsInitializing] = useState(true);
  const { handleCreateBillingAgreement } = useCreateBillingAgreement();
  const { handleOnApproveAction } = useHandleOnApproveAction();
  const { handleOnError } = useHandleOnError();

  return {
    isButtonsInitializing,
    setIsButtonsInitializing,
    handleCreateBillingAgreement,
    handleOnApproveAction,
    handleOnError,
  };
};
